module.exports = __webpack_public_path__ + "media/slot-game/heart-c60d5e79.svg";